import React from 'react'
import { getAdDataPanelListNewAPI, getSessionIdNewAPI } from '@/servers/agent-v2'
import { storagekeys } from '@/utils/storage/storegakey'
import storage from '@/utils/storage'
import { getStores } from '@/stores'
import { generateUUID } from '@/utils'

const useInitHistory = (opt: { autofetch: boolean }) => {
  const { agentV2Store } = getStores()
  const sessionIdRef = React.useRef('')
  const [loaded, setLoaded] = React.useState<boolean>(false)

  // 兼容性更好的滚动到底部方法
  const scrollToBottom = () => {
    const container = document.getElementById('ai-agent-main-container')
    if (!container) return

    const performScroll = () => {
      const { scrollHeight, clientHeight } = container
      const targetScrollTop = scrollHeight - clientHeight + 300

      // 兼容性更好的滚动方式
      if (container.scrollTo) {
        container.scrollTo({
          top: targetScrollTop,
          behavior: 'smooth'
        })
      } else {
        // 兼容老版本浏览器
        container.scrollTop = targetScrollTop
      }
    }

    // 检查 MutationObserver 支持
    if (typeof MutationObserver !== 'undefined') {
      let timeoutId: NodeJS.Timeout
      const observer: MutationObserver = new MutationObserver(() => {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
          performScroll()
          observer.disconnect()
        }, 100)
      })

      // 设置超时，防止无限等待
      timeoutId = setTimeout(() => {
        performScroll()
        observer.disconnect()
      }, 1000)

      // 开始监听 DOM 变化
      observer.observe(container, {
        childList: true,
        subtree: true
      })
    } else {
      // 不支持 MutationObserver 的备用方案
      setTimeout(() => {
        performScroll()
        // 重试一次确保滚动成功
        setTimeout(() => {
          performScroll()
        }, 300)
      }, 200)
    }
  }

  const initHistoryDataBySessionId = async (sessionId: string) => {
    agentV2Store.currentSessionId = sessionId
    const isCurrent = sessionId === agentV2Store.latestSessionId
    storage.set(storagekeys.currentSessionId, sessionId)

    const msgRes = await getAdDataPanelListNewAPI({
      session_id: sessionId,
      is_current: isCurrent
    })

    if (msgRes?.code === 0) {
      if (!msgRes?.data?.list?.length) {
        agentV2Store.renderMsgList = []
        agentV2Store.initMsgListData = true
        setLoaded(true)
        return
      }

      const arr = msgRes?.data?.list?.map?.(item => {
        return {
          id: generateUUID(),
          message_id: item.message_id || generateUUID(),
          placement: item.role === 'user' ? 'end' : ('start' as any),
          isFromHistory: true,
          isFeedback: item?.is_feedback || false,
          content: item?.content?.map?.(x => {
            return {
              ...x,
              styleType: x?.styleType || x?.style_type || 'normal',
              typing: false
            }
          })
        }
      })

      agentV2Store.renderMsgList = arr
      agentV2Store.initMsgListData = true
      setLoaded(true)

      // 使用兼容性更好的滚动方法
      scrollToBottom()
    }
  }

  const initHistory = async (history_session_id?: string) => {
    agentV2Store.initMsgListData = false
    setLoaded(false)
    try {
      //外部有传，表示只是拉取一下历史记录进行填充
      if (history_session_id) {
        await initHistoryDataBySessionId(history_session_id)
        return
      }

      const sessionRes = await getSessionIdNewAPI()
      await agentV2Store.initUserProfileData()

      if (sessionRes.code === 0 && sessionRes.data.session_id) {
        agentV2Store.latestSessionId = sessionRes.data.session_id
        await initHistoryDataBySessionId(sessionRes.data.session_id)
        sessionIdRef.current = sessionRes.data.session_id
        if (opt.autofetch) {
          // bi.reportLog({
          //   event_code: 'page_start',
          //   event_type: 'sf',
          //   page_id: 'agent_page',
          //   page_title: 'agent对话页面',
          //   properties: {
          //     session_id: sessionRes.data.session_id
          //   }
          // })
        }
        return
      } else {
        agentV2Store.initMsgListData = true
        setLoaded(true)
      }
    } catch (err) {
      console.error('err', err)
      agentV2Store.initMsgListData = true
      setLoaded(true)
    }
  }

  React.useEffect(() => {
    if (!agentV2Store.isInitSessionList) {
      return
    }

    if (opt.autofetch) {
      initHistory()
    }
  }, [agentV2Store.isInitSessionList, opt.autofetch])

  return {
    initHistory,
    loaded
  }
}

export default useInitHistory
